import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeContent extends Monitoring.Models.SocialContents.InboxContent

  type: ->
    'youtube'

  subType: ->
    'yt-comment'

  parentPostId: ->
    @getValue('videoId')

  getRootParentId: ->
    @parentPostId()

  avatar: ->
    avatarValue = @getValue('avatar')
    return super() unless avatarValue && avatarValue != 'null'
    avatarValue

  userId: ->
    @getValue('autorChannelId')

  name: ->
    @getValue('autor')

  hasProfile: ->
    true

  authorLink: ->
    @getValue('autorChannelUrl')

  getYoutubeVideoID: ->
    url = @link()
    url.substr(url.indexOf("?v=") + 3)

  getYoutubeCommentID: ->
    @getValue('id')

  getYoutubeCommentLink: ->
    "https://www.youtube.com/all_comments?v=#{@getYoutubeVideoID()}&lc=#{@getYoutubeCommentID()}"

  text: ->
    @getValue('comentario') #TODO youtube_dev solo en la subclase de comentarios
